import type { SerializedStyles } from "@emotion/serialize";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons";
import { faHourglassEnd } from "@fortawesome/pro-solid-svg-icons";

import type { VariantFragment } from "@shared/data/fragments/VariantFragment/VariantFragment.fragment";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { AvailabilityStatus } from "@shared/types/availabilityStatus";

import * as styles from "./VariantDropdownItemDescriptor.styles";

interface Props {
  descriptor: VariantFragment["descriptor"];
  availabilityStatus: VariantFragment["availabilityStatus"];
  descriptorStyle?: SerializedStyles;
}

const VariantDropdownItemDescriptor = ({
  descriptor,
  availabilityStatus,
  descriptorStyle,
}: Props) => {
  const renderOutOfStockDropdownItem = () => (
    <div
      css={[styles.dropdownItem, descriptorStyle]}
      data-testid="variant-out-of-stock-dropdown-item"
    >
      <span>{descriptor}</span>
      <FontAwesomeIcon css={styles.outOfStockIcon} icon={faExclamationCircle} />
    </div>
  );

  const renderBackorderedDropdownItem = () => {
    return (
      <div
        css={[styles.dropdownItem, descriptorStyle]}
        data-testid="variant-backordered-dropdown-item"
      >
        <span>{descriptor}</span>
        <FontAwesomeIcon css={styles.backorderedIcon} icon={faHourglassEnd} />
      </div>
    );
  };

  if (availabilityStatus === AvailabilityStatus.BACKORDERED) {
    return renderBackorderedDropdownItem();
  }

  if (availabilityStatus === AvailabilityStatus.UNAVAILABLE) {
    return renderOutOfStockDropdownItem();
  }

  if (availabilityStatus === AvailabilityStatus.NA) {
    return renderOutOfStockDropdownItem();
  }

  if (availabilityStatus === AvailabilityStatus.DISCONTINUED) {
    return renderOutOfStockDropdownItem();
  }

  if (availabilityStatus === AvailabilityStatus.FULLY_RESTRICTED) {
    return renderOutOfStockDropdownItem();
  }

  return <>{descriptor}</>;
};

export { VariantDropdownItemDescriptor };
